import React from "react";
import theme from "../../../styles/theme";



const Page23 = () => {
  return (

 
    <div>
    <h2>"Page 23" </h2>
    </div>


  );
};

export default Page23;
